import { data } from '../../svg/Library/data';
import { makeIcon } from '../makeIcon';

export const Library = makeIcon(data, 'library', 'Library');

export default Library;
